import { api } from '../../../services/api'

/**
 * Record that a recommended candidate was assigned, so recommendation_history
 * stops reporting "no decision" for every row (fue_asignado stayed NULL: the
 * recommenders never called the decision endpoint).
 *
 * Each candidate carries the history_id of the row the recommender saved it
 * as, and the decision goes on exactly that row. When it is missing (the
 * history insert failed, or an older backend), fall back to the latest
 * undecided history row for that person in the opportunity, which is the one
 * the recommender just showed. It is analytics only: failures are swallowed and
 * the caller never waits for it.
 */
export async function recordRecommendationAssigned(
    opportunityId: number | undefined,
    userId: number,
    historyId?: number | null,
): Promise<void> {
    try {
        if (historyId) {
            await api.recommendations.recordDecision(historyId, true)
            return
        }
        if (!opportunityId) return
        const res = await api.recommendations.getHistory(opportunityId, userId, 1)
        const latest = Array.isArray(res?.data) ? res.data[0] : null
        if (latest?.id && latest.fue_asignado == null) {
            await api.recommendations.recordDecision(latest.id, true)
        }
    } catch (err) {
        console.debug('Recommendation decision not recorded:', err)
    }
}
